export default __webpack_public_path__ + "static/media/callgrp.d9382e24.jpg";